module.exports = __webpack_public_path__ + "static/media/udemylogo.988aee0a.jpg";